import {rootState} from '@mintdata-wsp/common/state/RootState';
import {WSPIcons, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {TopBarButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/TopBarButton';
import {WspSidebar, WspSidebarLink} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/WspSidebar';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./HelpCenterButton.less');
const cx = classnames.bind(styles);

export interface ITopBarDotButtonProps
{
    className?:string;
}

@observer
export class HelpCenterButton extends React.Component<ITopBarDotButtonProps, any>
{
    private _handleClick = (event:React.MouseEvent<HTMLElement>) =>
    {
        // controllers.ui.mainPage.toggleHelpCenterVisibility();

        // const {lx} = controllers.ui;
        // lx.toggleLxFrameVisibility();

        event.preventDefault();
        window.open(WspSidebar.wspSidebarLinks[WspSidebarLink.HELP_CENTER].url);
    };

    public render():JSX.Element
    {
        const {isHelpCenterVisible} = rootState.ui.mainPage;

        const {className} = this.props;

        const tooltipContent = isHelpCenterVisible ? 'Close Help Center' : 'Help Center';

        return (
            <div className={cx('buttonWrapper')}>
                <TopBarButton
                    className={cx('base', className, {isHelpCenterVisible})}
                    iconProps={{
                        name: isHelpCenterVisible
                            ? WSPIcons.visualDesigner.topBar.Close
                            : WSPIcons.visualDesigner.topBar.Help,
                        size: WSPIconSize.medium24,
                        className: styles.helpBtnIcon
                    }}
                    onClick={this._handleClick}
                    tooltipProps={{
                        content: tooltipContent,
                        popoverProps: {
                            sourceAnchor: SourceAnchor.RightBottom,
                            popupAnchor: PopupAnchor.RightTop,
                            className: cx('tooltip')
                        }
                    }}
                    data-component="HelpCenterButton"
                />
            </div>
        );
    }
}
